module.exports = __webpack_public_path__ + "img/50_15.8603c59b.png";